import React from "react";
import { Button, CardFooter } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import { editProduct  } from "services/dataservice";
import { formatImages, formatAttributesValue } from "views/product/common";

export default function EditFormSubmit(props) {
  const history = useHistory();
  let { setAlert, product, basicInformation,parentSKU,productImages, brand, setBrand, attrNormals, setAttrNormals, variations, setVariations,groupData, optionImages, optionList, showFail } = props;

  const handleSubmit = async () => {
    let variationsClone = [...variations];
    let attrNormalsClone = [...attrNormals];

    // let validateImage = true;
    // let validateVariations = true;
    // let validateAttributes = true;
    let validate = true;

    if (basicInformation.productName.trim() === "" || basicInformation.description.trim() === "") {
      showFail("Product name / description cannot be empty");
      return;
    }

    if (brand.value === "" || brand.value === undefined) {
      let brandClone = { ...brand };
      brandClone.state = false;
      setBrand(brandClone);
      validate = false;
    }

    attrNormals.forEach((attr, i) => {
      if (attr.is_mandatory) {
        if (Array.isArray(attr.value)) {
          if (attr.value.length === 0) {
            attrNormalsClone[i]["state"] = false;
            setAttrNormals(attrNormalsClone);
            validate = false;
          }
        } else if (attr.value.trim() === "") {
          attrNormalsClone[i]["state"] = false;
          setAttrNormals(attrNormalsClone);
          validate = false;
        }
      }
    });
   
    //validation ori variations
    variationsClone.forEach((v) => {
      if (!v.inventoryId) {
        if (v.inventorySKU.trim() === "") {
          v.inventorySKUState = false;
          setVariations(variationsClone);
          validate = false;
        }
        if (v.barcode1.trim() === "") {
          v.barcode1State = false;
          setVariations(variationsClone);
          validate = false;
        }
        if (v.sellingPrice === "" || v.sellingPrice <= 0) {
          v.sellingPriceState = false;
          setVariations(variationsClone);
          validate = false;
        }
        if (v.weight === "" || v.weight <= 0) {
          v.weightState = false;
          setVariations(variationsClone);
          validate = false;
        }
        if (v.height === "" || v.height <= 0) {
          v.heightState = false;
          setVariations(variationsClone);
          validate = false;
        }
        if (v.width === "" || v.width <= 0) {
          v.widthState = false;
          setVariations(variationsClone);
          validate = false;
        }
        if (v.length === "" || v.length <= 0) {
          v.lengthState = false;
          setVariations(variationsClone);
          validate = false;
        }
      }else{
        if (v.sellingPrice === "" || v.sellingPrice <= 0) {
          v.sellingPriceState = false;
          setVariations(variationsClone);
          validate = false;
        }
      }
    });

    // if (!validateImage) {
    //   showFail("Each sku must have at least one image");
    //   return;
    // }
    if (!validate) {
      showFail("* must be filled");
      return;
    }

    if (window.confirm("Are you sure you want to update the product?")) {
      let productImagesReduced=formatImages(productImages)
      let attrs = formatAttributesValue(attrNormals);

      // let attrs = { ...attrMandatoriesReduced, ...attrNormalsReduced };

      // let newOptionImages = [];

      // for (let key in optionImages) {
      //   let oImages = {};
      //   oImages["option"] = key;
      //   oImages["image"] = formatImages(optionImages[key]);
      //   newOptionImages.push(oImages);
      // }

      let newVariations = variations.map((variation) => {
        let { variant, inventorySKUState, inventorySKUFound, sellingPriceState, barcode1State, weightState, heightState, widthState, lengthState, ...newVariation } = variation;
        return newVariation;
      });

      let productEdited = {
        productId:product.productId,
        catalogueBasicInfoId: product.catalogueBasicInfoId,
        description: basicInformation.description,
        productName: basicInformation.productName,
        parentSKU,
        categoryId: product.categoryId,
        categoryValue: product.categoryValue,
        // tags: product.tags,
        active: product.active,
        productImages:productImagesReduced,
        productGroup:groupData,
        brand: brand.value,
        isVariation: product.isVariation,
        platformName: product.platformName,
        userMarketplaceId: product.userMarketplaceId,
        // status: product.status,
        variations: newVariations,
        // optionImages: newOptionImages,
        options: optionList,
        attributes: attrs,
      };
      //console.log(groupData)
      //console.log(productEdited);
      // return;
      try {
        let response = await editProduct(productEdited);
        if (response.status === 200) {
          showSuccess("Product Updated", () => history.push("/admin/product/list"));
        }
      } catch (error) {
        showFail("Server Error [EditProduct]");
      }
    }
  };

   

  const showSuccess = (msg, callBack = null) => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={msg}
        onConfirm={() => (callBack == null ? setAlert(null) : callBack())}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="info"
      ></SweetAlert>
    );
  };
  return (
    <CardFooter>
      <Button onClick={handleSubmit} color="primary">
        Submit
      </Button>
      {/* <Button onClick={() => console.log(product)}>Preview Product In Console</Button> */}
       
    </CardFooter>
  );
}
